import { usobDropdownRoutes, vasDropdownRoutes } from "../utils/Constants"; // Adjust path as needed

export function getPageTitle(pathname) {
  const portal = localStorage.getItem("defPortal") === "USOB" ? usobDropdownRoutes : vasDropdownRoutes;
  const match = portal.find(route => route.id == pathname);
  return match ? match.value : pathname;
}
